import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { housingFundsCheckList } from '../../common/data';
import AlertButton from '../deductions/housingFunds/AlertButton';

import Type1CheckList from '../deductions/housingFunds/checklist/Type1';
import Type2CheckList from '../deductions/housingFunds/checklist/Type2';
import Type3CheckList from '../deductions/housingFunds/checklist/Type3';
import Type4CheckList from '../deductions/housingFunds/checklist/Type4';

//전자문서용
const HousingFundsCheckList = ({ onOpen, onClose, isOpen, housingFundsStatus }) => {
  const { t } = useTranslation('deductions/housingFunds');
  const checkList = housingFundsCheckList(t);
  const { htm013 } = useSelector(state => state.eDocuments);

  console.log('housingFundsStatus>>', housingFundsStatus);

  // 1 : 공제완료 2 : 공제불가 3 : 체크전
  const status = key => {
    if (Number(htm013) > 70000000) {
      if (key == 'htm104') {
        return '2';
      }
      if (Number(htm013) > 80000000) {
        if (key == 'htm105') {
          return '2';
        }
      }
    }
    return housingFundsStatus[key];
  };

  // const disabled = key => {
  //   if (Number(htm013) > 70000000) {
  //     if (key == 'htm104' || key == 'htm105') {
  //       return true;
  //     }
  //   }
  //   return false;
  // };

  return (
    <div className="displayFlexColumn" style={{ gap: '10px' }}>
      {checkList.map(
        (item, index) =>
          Object.hasOwn(housingFundsStatus, item.key) && (
            <AlertButton
              key={index}
              {...item}
              status={status(item.key)}
              // disabled={disabled(item.key)}
              onOpen={onOpen}
            />
          ),
      )}
      {/* 주택임차 */}
      <Type1CheckList
        isOpen={isOpen.checkList.type1}
        onClose={onClose}
        onOpen={onOpen}
        document={true}
      />
      {/* 장기주택 */}
      <Type2CheckList
        isOpen={isOpen.checkList.type2}
        onClose={onClose}
        onOpen={onOpen}
        document={true}
      />
      {/* 주택마련저축 */}
      <Type3CheckList
        isOpen={isOpen.checkList.type3}
        onClose={onClose}
        onOpen={onOpen}
        document={true}
      />
      {/* 월세액 */}
      <Type4CheckList
        isOpen={isOpen.checkList.type4}
        onClose={onClose}
        onOpen={onOpen}
        document={true}
      />
    </div>
  );
};

export default HousingFundsCheckList;
